export default __webpack_public_path__ + "static/media/visa.0a14e192.svg";